import React from 'react';

const Button = ({ width, label, type, disabled }) => {
  return (
    <button
      className={`btnSizes filledBtn ${width}`}
      type={type}
      disabled={disabled}
    >
      {label}
    </button>
  )
}

export default Button;